import { Anchor } from "@svea/design-system-components-react";
import ReactMarkdown from "react-markdown";
import { Li, Ol, Ul } from "../items";
import { Heading, Text } from "../typography";

type Props = {
	allowParagraphs?: boolean;
	className?: string;
	children: string;
};

export const Markdown = ({ children, className, allowParagraphs = false }: Props) => (
	<div className={className}>
		<ReactMarkdown
			components={{
				p({ children }) {
					return allowParagraphs ? (
						<Text component="p" className="mb-4">
							{children}
						</Text>
					) : (
						// biome-ignore lint/complexity/noUselessFragments: This is needed for some reason. Typing gets upset otherwise.
						<>{children}</>
					);
				},
				a({ children, href }) {
					return (
						<Anchor hasUnderline href={href} target="_blank">
							{children}
						</Anchor>
					);
				},
				ul({ children }) {
					return <Ul>{children}</Ul>;
				},
				ol({ children, ...rest }) {
					return <Ol {...rest}>{children}</Ol>;
				},
				li({ children }) {
					return <Li>{children}</Li>;
				},
				em({ children }) {
					return <em className="italic">{children}</em>;
				},
				h1({ children }) {
					return <Heading.H1>{children}</Heading.H1>;
				},
				h2({ children }) {
					return <Heading.H2>{children}</Heading.H2>;
				},
				h3({ children }) {
					return <Heading.H3>{children}</Heading.H3>;
				},
				h4({ children }) {
					return <Heading.H4>{children}</Heading.H4>;
				},
				// add more tags when needed, e.g. <li>, <em> etc
			}}
		>
			{children}
		</ReactMarkdown>
	</div>
);
